import { Seo } from "../components/Seo";
import { Reveal, Eyebrow } from "../components/Reveal";
import ServiceArea from "../components/sections/ServiceArea";
import CtaBand from "../components/sections/CtaBand";
import { Marquee } from "../components/Marquee";
import { CITIES } from "../lib/data";

const ServiceAreas = () => (
  <main data-testid="service-areas-page">
    <Seo
      title="Service Areas | Gas Station Contractor Milton & GTA | Petroline Services"
      description="Petroline Services is based in Milton, ON and serves petroleum retail facilities across Mississauga, Oakville, Burlington, Brampton, Vaughan, Toronto, Hamilton, Guelph, Cambridge and Kitchener-Waterloo."
    />

    <section className="mx-auto max-w-7xl px-5 pb-8 pt-24 lg:px-8 lg:pt-32">
      <Reveal>
        <Eyebrow>Service Areas</Eyebrow>
        <h1 className="max-w-3xl font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
          Based in Milton. <span className="text-ember">Working Across Southern Ontario.</span>
        </h1>
      </Reveal>
    </section>

    <Marquee items={CITIES} testId="service-areas-marquee" />
    <ServiceArea />
    <CtaBand title="Have a facility in our service area?" subtitle="Contact Petroline Services to discuss repair, renovation and maintenance support for your location." />
  </main>
);

export default ServiceAreas;
